export const CAROUSEL_SCROLL_WIDTH = 271; // Item Width (259px) + Carousel X Padding (12px)
export const FOUR_CARD_LAYOUT_VARIANT = 'fourCardLayout';
